import React, {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import {Link} from 'react-router-dom'

import * as userInteractionsActions from '../../../actions/userInteractions'
import {TransactionType} from '../../../pages/OrderManager/OrderManager/types'
import {ADDRESS_UPDATE, NEW_RENT_TO_KEEP, REMOVE_ITEMS_PAGE} from '../../../urls'
import {formatSqlDate} from '../../../utils'
import {toPath} from '../../../utils/urlUtils'
import SolvvyButton, {SOLVVY_REQUEST_EXTENSION} from '../../_shared/SolvvyButton'
import {EventData, EventOrder} from '../types/eventData'
import {OrderData} from '../types/orderData'

import Anchor from '../../Anchor'
import {ButtonGroupList} from '../_components/ButtonGroupList'

import Button from '../../Button'
import styles from './styles.module.scss'

interface OrderDetails {
  eventData: EventData
  eventOrder: EventOrder
  orderData: OrderData
}

const OrderDetails: React.FC<OrderDetails> = ({eventData, eventOrder, orderData}) => {
  const dispatch = useDispatch()
  const openModal = useCallback(() => {
    dispatch(userInteractionsActions.openPrintReturnLabelModal())
  }, [dispatch])

  const {arrivalDate, returnByDate, shippingAddress1, transactionType} = orderData
  const {homeTryOn} = eventOrder
  const eventId = orderData.event.id
  const orderId = eventOrder.id
  const isRental = transactionType === TransactionType.Rent

  return (
    <div className={styles.container}>
      <ul className={styles.details}>
        <li>
          <span className={styles.title}>Order Number</span>
          <span className={styles.content}>{orderId}</span>
        </li>
        <li>
          <span className={styles.title}>Delivery Details</span>
          <a className={styles.address} href={toPath(ADDRESS_UPDATE, {eventId, orderId})}>
            {shippingAddress1}
          </a>
        </li>
        <li>
          <span className={styles.title}>Estimated Arrival</span>
          <span className={styles.content}>{arrivalDate ? formatSqlDate(arrivalDate) : ''}</span>
        </li>
        <li>
          <span className={styles.title}>Event Date</span>
          <span className={styles.content}>{formatSqlDate(eventData.event.date)}</span>
        </li>
        {isRental && (
          <li>
            <span className={styles.title}>Return Date</span>
            <span className={styles.content}>
              {returnByDate ? formatSqlDate(returnByDate) : ''}
            </span>
          </li>
        )}
      </ul>

      <ButtonGroupList>
        {!homeTryOn && isRental && (
          <li>
            <SolvvyButton workflowId={SOLVVY_REQUEST_EXTENSION}>Request Extension</SolvvyButton>
          </li>
        )}
        <li>
          <Button className={styles['print-btn']} onClick={openModal}>
            Print Return Label
          </Button>
        </li>
        <li>
          <Link
            to={{
              pathname: toPath(REMOVE_ITEMS_PAGE, {eventId, orderId}),
              state: {isCancelOrderLink: true},
            }}
          >
            Cancel Order
          </Link>
        </li>
        {!homeTryOn && isRental && (
          <li>
            <Anchor shouldOpenNewTab={false} href={toPath(NEW_RENT_TO_KEEP, {eventId})}>
              Keep my rental
            </Anchor>
          </li>
        )}
      </ButtonGroupList>
    </div>
  )
}

export default OrderDetails
